import { Divider, Grid2 as Grid, Typography } from "@mui/material";
import { useStyles } from "./PriorityStock.styles";
import { PriorityStockItemArrayProps } from "./types";

export const PriorityStockGroupItems = ({ items }: PriorityStockItemArrayProps) => {
	const classes = useStyles();
	return (
		<Grid container direction="column" size={12}>
			{items.map((row, i) => (
				<Grid container key={row.sku}>
					<Grid container direction="row" size={12}>
						<Grid size={9}>
							<Typography component="div">
								<Typography component="div" variant="body2">
									{row.description}
								</Typography>
								<Typography component="div" variant="body2" className={classes.typographyBody2}>
									MODEL: {row.model}
								</Typography>
							</Typography>
						</Grid>
						<Grid container justifyContent="flex-end" size={3}>
							<Typography component="div">
								<Typography component="div" variant="body2" className={classes.typographyBody2}>
									{row.invoiced} Units
								</Typography>
								<Typography component="div" variant="body2" className={classes.typographyBody2}>
									<strong>${row.unitCost?.toFixed(2)}</strong>
								</Typography>
							</Typography>
						</Grid>
					</Grid>
					<Grid size={12}>
						<Typography component="div" variant="body2" className={classes.typographyBody2}>
							Group: <strong>{row.productGroup}</strong>
						</Typography>
					</Grid>
					<Grid size={12}>
						<Typography component="div" variant="body2" className={classes.typographyBody2}>
							SKU: <strong>{row.sku}</strong>
						</Typography>
					</Grid>
					{row.reason && (
						<Grid size={12}>
							<Typography component="div" variant="body2" className={classes.typographyBody2}>
								Reason: {row.reason}
							</Typography>
						</Grid>
					)}
					{i < items.length - 1 && (
						<Grid size={12}>
							<Divider className={classes.divider} />
						</Grid>
					)}
				</Grid>
			))}
		</Grid>
	);
};
